import React from 'react';
import _ from 'lodash';

export default class WapFilterModal extends React.Component {
  constructor(props) {
    super(props);
    this.disableBodyScrollIfOpenAndNotNested();
  }

  disableBodyScrollIfOpenAndNotNested() {
    const { open, nested } = this.props;
    if (nested) return;
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'auto';
  }

  getMemoizedStyles = _.memoize(
    ({ open, nested, clearAllFiltersButtonDisabled }) => ({
      modal: {
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        display: open ? 'flex' : 'none',
        backgroundColor: nested ? 'transparent' : 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 5%',
        zIndex: 1050,
      },
      modal__content: {
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
      },
      modal__content__header: {
        padding: '1.5rem',
        borderBottom: '0.8px solid rgb(244, 242, 244)',
        display: 'flex',
        justifyContent: 'space-between',
      },
      modal__content__body: {
        padding: '1.5rem',
        flex: 1,
        overflow: 'scroll',
      },
      'go-back-button': {
        fontSize: '1.8rem',
        lineHeight: '2.5rem',
        backgroundColor: 'transparent',
        margin: 0,
        padding: '1rem',
        border: 'none',
      },
      'clear-all-filters-button': {
        fontSize: '1.3rem',
        backgroundColor: '#f2f2f2',
        border: 'none',
        padding: '1rem 2.7rem',
        margin: 0,
        color: clearAllFiltersButtonDisabled ? '#b3b3b3' : 'rgb(0, 0, 0)',
      },
      'category-option': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1.5rem',
        border: '0.8px solid rgb(244, 242, 244)',
      },
      'category-option__display-name': {
        fontWeight: 'bold',
        fontSize: '1.6rem',
      },
    }),
    ({ open, nested, clearAllFiltersButtonDisabled }) => [
      open,
      nested,
      clearAllFiltersButtonDisabled,
    ],
  );

  componentWillUnmount() {
    const { nested } = this.props;
    if (nested) return;
    document.body.style.overflow = 'auto';
  }

  componentDidUpdate({ open: prevOpen }) {
    const { open } = this.props;
    if (prevOpen !== open) {
      this.disableBodyScrollIfOpenAndNotNested();
    }
  }

  render() {
    const { onCloseClick, onClearAllFiltersButtonClick, clearAllFiltersButtonDisabled, children } =
      this.props;

    const styles = this.getMemoizedStyles(this.props);

    return (
      <div style={styles.modal}>
        <div style={styles.modal__content}>
          <div style={styles.modal__content__header}>
            <div>
              <i className="icon-flecha_gruesa_izq" />
              <button onClick={onCloseClick} style={styles['go-back-button']}>
                Regresar
              </button>
            </div>
            <button
              onClick={clearAllFiltersButtonDisabled ? undefined : onClearAllFiltersButtonClick}
              style={styles['clear-all-filters-button']}
            >
              Limpiar filtros
            </button>
          </div>
          <div style={styles.modal__content__body}>{children}</div>
        </div>
      </div>
    );
  }
}
